import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch } from "~/hooks/reduxHooks";
import { openPreferencesModal } from "~/store/layoutSlice";

interface OpenPreferencesRedirectProps {
	tab?: string;
}

const OpenPreferencesRedirect = ({ tab }: OpenPreferencesRedirectProps) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(openPreferencesModal(tab));
		navigate("/", { replace: true });
	}, []);

	return null;
};

export default OpenPreferencesRedirect;
